import { createQueryFactory } from "../query-factory";

export const { useApiHook: useSimplifiedPlaces } = createQueryFactory(
	"getSimplifiedPlaces",
);

export const { useApiHook: useGetPlaceProducts } = createQueryFactory("getPlaceProducts");

export const { useApiHook: useGetAddressFromCep } = createQueryFactory(
	"getAddressFromCep",
);
export const { useApiHook: useGetPlaceSettingsGeneralSection } = createQueryFactory(
	"getPlaceSettingsGeneralSection",
);

export const { useApiHook: useGetPlaceFeatures } = createQueryFactory("getPlaceFeatures");

export const { useApiHook: useGetPlace } = createQueryFactory("getPlace");

export const { useApiHook: useGetPromotionsUsedAtPlace } = createQueryFactory(
	"getPromotionsUsedAtPlace",
);

export const { useApiHook: useGetUserPromotionsUsedAtPlace } = createQueryFactory(
	"getUserPromotionsUsedAtPlace",
);

export const usePlaceBars = (placeId: string) => {
	const { data, isLoading, error } = useGetPlace({ placeId });

	return {
		data: data?.place?.bars ?? [],
		isLoading,
		error,
	};
};

export const { useApiHook: useGetResumeForPlaceInSections } = createQueryFactory(
	"getResumeForPlaceInSections",
);

export const {
	useApiHook: useGetClosingResumeReportForPlaceInSections,
} = createQueryFactory("getClosingResumeReportForPlaceInSections");
export const useGetEventOperationsByPlaceId = (params: {
	request: {
		filters: { placeId: string };
		pagination: { currentPage: number; perPage: number };
	};
}) => {
	const { useApiHook } = createQueryFactory("getEventOperationsByPlaceId");

	const isValidParams = Boolean(
		params.request.filters.placeId &&
			params.request.filters.placeId.trim() !== "" &&
			params.request.pagination.currentPage >= 0 &&
			params.request.pagination.perPage > 0,
	);

	return useApiHook(params, {
		enabled: isValidParams,
	});
};

export const useRequestClosingOfEventOperation = (params: { id: string }) => {
	const { useApiHook } = createQueryFactory("requestClosingOfEventOperation", {
		retry: false,
		refetchInterval: false,
		refetchOnWindowFocus: false,
		refetchOnMount: false,
		refetchOnReconnect: false,
		refetchIntervalInBackground: false,
	});

	const isValidParams = Boolean(params.id && params.id.trim() !== "");

	return useApiHook(
		{ id: params.id },
		{
			enabled: isValidParams,
			refetchOnMount: isValidParams,
		},
	);
};
